











import Vue from "vue";
import Component from "vue-class-component";

@Component({
  metaInfo: {
    title: "Statusbearbeitung",
  },
})
export default class StateManagement extends Vue {}
